
<div class="container">


  <h2 class="content-heading"> 
        Lectionary Item Name Validator
  </h2>


  <div class="blockX">

    <div class="row">
      
        <div class="col-6">
            <div class="form-material validateInput">
                <input matInput  [(ngModel)]="passage">
                <label for="">Name</label>
            </div>
          </div>

          <div class="col-6">
              <div class="form-material validateInput">
                  <span *ngIf="result == null" class="notValidated">Could not validate</span>
                  <span *ngIf="result == passage" class="valid">{{result}}</span>
                  <span *ngIf="result != passage" class="corrected">{{result}}</span> 
                  <label for="">Result</label>
              </div>
            </div>
  
    </div>

    <div class="row">
      
        <div class="col-sm-12">
            <button (click)="validate()" style="margin-top:10px;">Validate</button>
        </div>
  
    </div>
 
 
  </div>

</div>


